import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import { LoungeScreen } from '../../shared/components/Lounge';

function formatTime(ms) {
  if (ms <= 0) return '00:00';
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function Cooldown() {
  const location  = useLocation();
  const navigate  = useNavigate();
  const { cooldownUntil } = location.state ?? {};

  const [remaining, setRemaining] = useState(
    cooldownUntil ? Math.max(0, new Date(cooldownUntil) - Date.now()) : 0
  );

  useEffect(() => {
    if (!cooldownUntil) {
      navigate(ROUTES.ENTER, { replace: true });
      return;
    }

    const tick = () => {
      const ms = Math.max(0, new Date(cooldownUntil) - Date.now());
      setRemaining(ms);
      if (ms === 0) clearInterval(id);
    };

    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [cooldownUntil, navigate]);

  const done = remaining === 0;

  return (
    <LoungeScreen>
      <span className="relative mb-4 inline-flex items-center gap-2 rounded-full border border-lounge-line bg-lounge-card
                       px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-lounge-brass">
        <span aria-hidden className={`h-1.5 w-1.5 rounded-full ${done ? 'bg-felt' : 'bg-lounge-brass'}`} />
        {done ? 'Listo' : 'Tiempo de espera'}
      </span>
      <h1 className="relative font-serif text-[40px] font-semibold leading-[1.1] tracking-tight">
        {done ? <>Ya puedes<br /><span className="italic text-lounge-brass">volver a elegir.</span></>
              : <>Vuelve en<br /><span className="italic text-lounge-brass">un momento.</span></>}
      </h1>

      <div className="relative mt-8 w-full rounded-lg border border-lounge-line bg-lounge-card px-6 py-8 shadow-sleeve">
        <p aria-live="polite" className="font-mono text-6xl font-medium tabular-nums text-lounge-text">
          {formatTime(remaining)}
        </p>
        <p className="mt-3 text-sm text-lounge-stone">
          {done ? 'Escanea el QR del local para elegir más canciones.' : 'para poder escanear el QR de nuevo'}
        </p>
      </div>
    </LoungeScreen>
  );
}
